export default __webpack_public_path__ + "images/VI.713123b.png";